// src/routes/index.js
import baseRoutes from './baseRoutes';
import adminRoutes from './adminRoutes';
import courierRoutes from './courierRoutes';
import logistRoutes from './logistRoutes';
import dispatcherRoutes from './dispatcherRoutes';
import managerRoutes from './managerRoutes';
import DeveloperRoutes from './developerRoutes';
import StorekeeperRoutes from './StorekeeperRoutes.js'
const routes = [
  ...baseRoutes,
  ...adminRoutes,
  ...courierRoutes,
  ...logistRoutes,
  ...dispatcherRoutes,
  ...managerRoutes,
  ...DeveloperRoutes,
  ...StorekeeperRoutes,
];

export default routes;
